"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Table as i, Paragraph as h, Group as l, Icon as c, TextLink as o } from "@ingeniorforeningen/figurine-core";
import { forwardRef as g } from "react";
import '../../../../assets/TablesContact.css';const b = "_header_gwbtf_2", u = {
  header: b
}, s = g((m, p) => {
  const { items: n } = m;
  return /* @__PURE__ */ t("div", { ref: p, children: [
    /* @__PURE__ */ t(i, { hiddenFrom: "sm", children: [
      n?.headers && n.headers.length > 0 && /* @__PURE__ */ e(i.Thead, { children: /* @__PURE__ */ e(i.Tr, { children: /* @__PURE__ */ e(i.Th, { "aria-label": n.headers?.[0], children: /* @__PURE__ */ e(h, { text: n.headers?.[0], align: "left", variant: "light" }) }) }) }),
      n?.rows && n.rows.length > 0 && /* @__PURE__ */ e("tbody", { children: n.rows?.map((a, d) => /* @__PURE__ */ e(
        i.Tr,
        {
          className: u.tableRowSmallViewport,
          children: /* @__PURE__ */ e(i.Td, { children: /* @__PURE__ */ t(l, { direction: "column", py: "xs", children: [
            /* @__PURE__ */ t(l, { align: "center", wrap: "nowrap", children: [
              a.icon && /* @__PURE__ */ e(c, { name: a.icon, color: "dark" }),
              /* @__PURE__ */ e(h, { condensed: !0, strong: !0, text: a.header })
            ] }),
            a.content?.map((r) => /* @__PURE__ */ t(l, { align: "center", wrap: "nowrap", children: [
              /* @__PURE__ */ e(c, { name: "PhoneCall", color: "dark" }),
              /* @__PURE__ */ t(l, { direction: "column", spacing: 0, children: [
                /* @__PURE__ */ e(h, { text: r.text, condensed: !0 }),
                (r.phoneNumber || r.link) && /* @__PURE__ */ t(l, { children: [
                  r.phoneNumber && /* @__PURE__ */ e(o, { variant: "component", ...r.phoneNumber }),
                  r.link && r.phoneNumber && /* @__PURE__ */ e(h, { text: " / " }),
                  r.link && /* @__PURE__ */ e(
                    o,
                    {
                      variant: "component",
                      href: r.link.href,
                      target: r.link.target,
                      text: r.link.text
                    }
                  )
                ] })
              ] })
            ] }, `tableContactText${r.text}`))
          ] }) })
        },
        `tableContactRow${d}`
      )) })
    ] }),
    /* @__PURE__ */ t(i, { visibleFrom: "sm", children: [
      n?.headers && n.headers.length > 0 && /* @__PURE__ */ e(i.Thead, { children: /* @__PURE__ */ e(i.Tr, { children: n.headers?.map((a, d) => /* @__PURE__ */ e(i.Th, { "aria-label": a, children: /* @__PURE__ */ e(h, { text: a, align: d === 0 ? "left" : "right", variant: "light" }) }, `tableContactHeader${d}`)) }) }),
      n?.rows && n.rows.length > 0 && /* @__PURE__ */ e(i.Tbody, { children: n.rows.map((a, d) => /* @__PURE__ */ t(i.Tr, { children: [
        /* @__PURE__ */ e("td", { children: /* @__PURE__ */ t(l, { align: "center", wrap: "nowrap", children: [
          a.icon && /* @__PURE__ */ e(c, { name: a.icon, color: "dark" }),
          /* @__PURE__ */ e(h, { condensed: !0, text: a.header })
        ] }) }),
        /* @__PURE__ */ e("td", { children: a.content && a.content.length > 0 && /* @__PURE__ */ e(l, { direction: "column", spacing: "sm", children: a.content.map((r) => /* @__PURE__ */ t(
          l,
          {
            direction: "column",
            spacing: 0,
            children: [
              /* @__PURE__ */ e(h, { condensed: !0, text: r.text, align: "right" }),
              (r.phoneNumber || r.link) && /* @__PURE__ */ t(l, { justify: "right", spacing: "sm", children: [
                r.phoneNumber && /* @__PURE__ */ e(o, { variant: "component", ...r.phoneNumber }),
                r.link && r.phoneNumber && /* @__PURE__ */ e(h, { text: "/" }),
                r.link && /* @__PURE__ */ e(
                  o,
                  {
                    variant: "component",
                    href: r.link.href,
                    target: r.link.target,
                    text: r.link.text
                  }
                )
              ] })
            ]
          },
          `tableContactText${r.text}`
        )) }) })
      ] }, `tableContactRow${d}`)) })
    ] })
  ] });
});
s.displayName = "TablesContact";
const f = s;
export {
  s as _TablesContact,
  f as default
};
